// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rp-6";
export var imgContainer = "_rp-3";
export var menuIcon = "_rp-5";
export var pillWrapper = "_rp-2";
export var pillsContainer = "_rp-1";
export var subscriptionCard = "_rp-0";
export var subscriptionLogo = "_rp-4";